﻿import { Inject, Injectable } from '@angular/core';

@Injectable()
export class HelperService {
    constructor() { }

    ScrollUp() {
        var scrollTimeOut = setTimeout(function () {
            clearTimeout(scrollTimeOut);
            window.scroll(0, 0);
        }, 100);
    }

    activeBrowser = function () {
        var ua = navigator.userAgent, tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE-' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    }();


    formatPhone(value) {
        if (value == null || value.length == 0)
            return "";

        let newPhone = '';
        switch (value.length) {
            case 10:
            case 9:
            case 8:
            case 7:
                newPhone = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);
                break;
            case 6:
            case 5:
            case 4:
                newPhone = value.slice(0, 3) + '-' + value.slice(3, 6);
                break;
            default:
                newPhone = value;
                break;

        }
        return newPhone;
    }


    getSiteAddress(site) {
        var address = '';
        if (!(site.HouseNumber == null && site.HouseNumber == ''))
            address += site.HouseNumber;
        if (!(site.StreetName != null && site.StreetName == ''))
            address += ' ' + site.StreetName;
        if (address.trim() != '')
            address = ' - ' + address.trim();

        return address;
    }

    getRoleName(roleId) {
        var roleid = +roleId;
        var roleName = '';
        switch (roleid) {
            case 1030:
                roleName = "Applicant";
                break;
            case 1765:
                roleName = "Owner";
                break;
            case 1880:
                roleName = "Attorney";
                break;
            default:
                roleName = "";
        }
        return roleName;
    }

    getSiteRoleName(roleId) {
        var roleid = +roleId;
        var roleName = '';
        switch (roleid) {
            case 1030:
                roleName = "Applicant";
                break;
            case 1031:
                roleName = 'Administering Agent';
                break;
            case 1032:
                roleName = "Architect";
                break;
            case 1035:
                roleName = "General Contractor";
                break;
            case 1765:
                roleName = "Owner";
                break;
            case 1880:
                roleName = "Attorney";
                break;
            case 2077:
                roleName = "Ground Lessee";
                break;
            default:
                roleName = ""; 
        }
        return roleName;
    }

    scrollUp() {
        var scrollTimeOut = setTimeout(function () {
            clearTimeout(scrollTimeOut);
            window.scroll(0, 0);
        }, 100);
    }

}
